export const VERSION = '0.10.0'

export { installPostCommitHook, removePostCommitHook, HOOK_MARKER } from './provisioning/hooks.js'
